<script>
  //全局路径
  var globalPath = {
    api: "/api/", //主页调用接口地址
    downlaod: "/template/", //静态资源模版下载
    app: "/app/", //静态资源模版下载
    BI:'/BI/',
  };
  let path;
  let bi;
  if (process.env.NODE_ENV === "development") {
    // dev
    path = "/base/"; //登陆页面接口地址
  } else {
    // build
    path = "/signIn/"; //登陆页面接口地址
    globalPath.BI = '/tgw/tmd/';
  }
  globalPath.url = path;
  

  //打包时，获取各打包 环境的地址
  if(process.env.NODE_ENV === 'testing' || process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'presentation'){
    for(let key in globalPath){
      globalPath[key] = process.env.API_ROOT + globalPath[key];
      console.log(globalPath[key]);
    }
  }

  export default {
    globalPath
  };
</script>



// WEBPACK FOOTER //
// src/assets/script/globalPath.vue